import { FieldNames } from "./FieldNames";
import i18next from "i18next";
import { translateAndSortAscendant } from "../../../common/helper";
import NameOrEmail from "./components/NameOrEmail";
import AdvanceSearchBetweenDates from "./components/AdvanceSearchBetweenDates";
import { Managers } from "./components/Managers";
import { InactiveManagers } from "./components/InactiveManagers";
import CompetencesAndSkills from "./components/CompetencesAndSkills";
import AdvancesearchRating from "./components/AdvanceSearchRating";
import PersonalSkillsAndCompetences from "./components/PersonalSkillsAndCompetences";
import LinkedIn from "./components/LinkedIn";
import Notes from "./components/Notes";
import PersonalCharacteristics from "./components/PersonalCharacteristics";
import Availability from "./components/Availability";
import IsNegotiable from "./components/IsNegotialble";
import ExitReason from "./components/ExitReason";
import OtherProposals from "./components/OtherProposals";
import CandidateSalary from "./components/CandidateSalary"
import DesireContractType from "./components/DesireContractType";
import SalaryInformation from "./components/SalaryInformation";
import ManagerInterest from "./ManagerInterest";
import YearsOFExperience from "./components/YearsOfExperience";
import MainActivities from "./components/MainActivities";
import PersonalProfile from "./components/PersonalProfile";
import Comments from "./components/Comments";
import Zones from "./components/Zone";
import Mobility from "./components/Mobility";
import RemoteWork from "./components/RemortWork";
import BirthDate from "./components/BirthDate";
import MaritalStautus from "./components/MaritalStauts";
import NumberOfDependants from "./components/NumberOfDependants";
import Nationality from "./components/Nationality";
import NeedDocumentation from "./components/NeedDocumentation";
import MobileNumber from "./components/MobileNumber";
import GitHub from "./components/GitHub";
import Courses from "./components/Courses";
import CourseByDate from "./components/CourseByDate";
import Instituition from "./components/Institution";
import Language from "./components/Language";
import FinalClassification from "./components/FinalClassification";
import EducationNotes from "./components/EducationNotes";
import OtherSkills from "./components/OtherSkills";
import CurrentContractType from "./components/CurrentContractType";
import CourseOnGoing from "./components/CourseOnGoing";
import Recommended from "./components/Recommended";
import SeniorityLevel from "./components/SeniorityLevel";
import { CurrentLocation } from "./components/CurrentLocation";
import BusinessArea from "./components/BusinessArea";
import BusinessAreaInterest from "./components/BusinessAreaInterest";
import TechArea from "./components/TechArea";
import TechAreaInterest from "./components/TechAreaInterest";
import JobRole from "./components/JobRole";
import Tags from "./components/Tags";

export const DropDownQuickSearchOptions = {
  getOptions() {
    let options = [
      {
        description: i18next.t("Personal Information - Name Or Email"),
        id: FieldNames.nameOrEmail,
        input: () => <NameOrEmail />
      },
      {
        description: i18next.t("Global - Business Area"),
        id: FieldNames.businessArea,
        input: () => <BusinessArea />
      },
      {
        description: i18next.t("Global - Business Area Interest"),
        id: FieldNames.candidateInterestBusinessArea,
        input: () => <BusinessAreaInterest />
      },
      {
        description: i18next.t("Global - Tech Area / Tech Role"),
        id: FieldNames.techArea,
        input: () => <TechArea />
      },
      {
        description: i18next.t("Global - Tech Area Interest / Tech Role Interest"),
        id: FieldNames.candidateInterestTechArea,
        input: () => <TechAreaInterest />
      },
      {
        description: i18next.t("Global - Job Role"),
        id: FieldNames.jobRoleId,
        input: () => <JobRole />
      },
      {
        description: i18next.t("Global - Tags"),
        id: FieldNames.tags,
        input: () => <Tags />
      },
      {
        description: i18next.t("Global - Between Dates"),
        id: FieldNames.betweenDates,
        input: () => <AdvanceSearchBetweenDates />
      },
      {
        description: i18next.t("Global - Manager"),
        id: FieldNames.managerId,
        input: () => <Managers />
      },
      {
        description: i18next.t("Global - Others Managers"),
        id: FieldNames.inactiveManagerId,
        input: () => <InactiveManagers />
      },
      {
        description: i18next.t("Competences - Skills"),
        id: FieldNames.skills,
        input: () => <CompetencesAndSkills />
      },
      {
        description: i18next.t("Competences - Other Skills"),
        id: FieldNames.otherSkills,
        input: () => <OtherSkills />
      },
      {
        description: i18next.t("Global - Rating"),
        id: FieldNames.rating,
        input: () => <AdvancesearchRating />
      },
      {
        description: i18next.t("Competences - Personal Skills and Competences"),
        id: FieldNames.competences,
        input: () => <PersonalSkillsAndCompetences />
      },
      {
        description: i18next.t("Global - Global Notes"),
        id: FieldNames.addNote,
        input: () => <Notes />
      },
      {
        description: i18next.t("Work - Personal Characteristics"),
        id: FieldNames.personnalCharacteristics,
        input: () => <PersonalCharacteristics />
      },
      {
        description: i18next.t("Conditions - Availability"),
        id: FieldNames.availability,
        input: () => <Availability />
      },
      {
        description: i18next.t("Conditions - Is Negotiable"),
        id: FieldNames.isNegotiable,
        input: () => <IsNegotiable />
      },
      {
        description: i18next.t("Global - Recommended"),

        id: FieldNames.recommended,
        input: () => <Recommended />
      },

      {
        description: i18next.t("Conditions - Exit Reason"),
        id: FieldNames.exitReason,
        input: () => <ExitReason />
      },
      {
        description: i18next.t("Conditions - Other Proposals"),
        id: FieldNames.otherProposals,
        input: () => <OtherProposals />
      },
      {
        description: i18next.t("Conditions - Expected Salary"),
        id: FieldNames.expectedSalary,
        input: () => <CandidateSalary 
        description={i18next.t("Conditions - Expected Salary")}/>
      },
      {
        description: i18next.t("Conditions - Desired Contract Type"),
        id: FieldNames.desiredContractTypeId,
        input: () => <DesireContractType />
      },
      {
        description: i18next.t("Conditions - Salary Information"),
        id: FieldNames.salaryInformation,
        input: () => <SalaryInformation />
      },
      {
        description: i18next.t("Global - Manager Interest"),
        id: FieldNames.managerInterestId,
        input: () => <ManagerInterest />
      },
      {
        description: i18next.t("Conditions - Current Salary"),
        id: FieldNames.CurrentSalary,
        input: () => <CandidateSalary 
        description={i18next.t("Conditions - Current Salary")}/>
      },
      {
        description: i18next.t("Conditions - Current Contract Type"),
        id: FieldNames.currentContractTypeId,
        input: () => <CurrentContractType />
      },
      {
        description: i18next.t("Work - Professional Experience Years"),
        id: FieldNames.professionalExperienceYearsId,
        input: () => <YearsOFExperience />
      },
      {
        description: i18next.t("Work - Seniority Level"),
        id: FieldNames.seniorityLevelsId,
        input: () => <SeniorityLevel />
      },
      {
        description: i18next.t("Work - Main Activities"),
        id: FieldNames.mainActivities,
        input: () => <MainActivities />
      },
      {
        description: i18next.t("Work - Personal Profile"),
        id: FieldNames.personalProfile,
        input: () => <PersonalProfile />
      },
      {
        description: i18next.t("Work - Comments"),
        id: FieldNames.comments,
        input: () => <Comments />
      },
      {
        description: i18next.t("Personal Information - Zone"),
        id: FieldNames.zoneId,
        input: () => <Zones />
      },
      {
        description: i18next.t("Conditions - Mobility"),
        id: FieldNames.mobility,
        input: () => <Mobility />
      },
      {
        description: i18next.t("Conditions - Remote Work"),
        id: FieldNames.remoteWorkId,
        input: () => <RemoteWork />
      },
      {
        description: i18next.t("Personal Information - Birth Date"),
        id: FieldNames.birthDate,
        input: () => <BirthDate />
      },
      {
        description: i18next.t("Personal Information - Marital Status"),
        id: FieldNames.maritalStatusId,
        input: () => <MaritalStautus />
      },
      {
        description: i18next.t("Personal Information - Number Of Dependants"),
        id: FieldNames.numberOfDependantId,
        input: () => <NumberOfDependants />
      },
      {
        description: i18next.t("Personal Information - Nationality"),
        id: FieldNames.nationalityId,
        input: () => <Nationality />
      },
      {
        description: i18next.t("Personal Information - Need Documentation"),
        id: FieldNames.needDocumentation,
        input: () => <NeedDocumentation />
      },
      {
        description: i18next.t("Contact Information - Mobile Number"),
        id: FieldNames.mobileNumber,
        input: () => <MobileNumber />
      },
      {
        description: i18next.t("Contact Information - LinkedIn"),
        id: FieldNames.linkedIn,
        input: () => <LinkedIn />
      },
      {
        description: i18next.t("Contact Information - GitHub"),
        id: FieldNames.gitHub,
        input: () => <GitHub />
      },
      {
        description: i18next.t("Education - Course"),
        id: FieldNames.courseId,
        input: () => <Courses />
      },
      {
        description: i18next.t("Education - Institution"),
        id: FieldNames.institutionId,
        input: () => <Instituition />
      },
      {
        description: i18next.t("Education - Course By Date"),
        id: FieldNames.coursebyDate,
        input: () => <CourseByDate />
      },
      {
        description: i18next.t("Education - Course OnGoing"),
        id: FieldNames.courseOnGoing,
        input: () => <CourseOnGoing />
      },
      {
        description: i18next.t("Education - Final Classification"),
        id: FieldNames.finalClassification,
        input: () => <FinalClassification />
      },
      {
        description: i18next.t("Education - Notes"),
        id: FieldNames.notes,
        input: () => <EducationNotes />
      },
      {
        description: i18next.t("Competences - Language"),
        id: FieldNames.languageId,
        input: () => <Language />
      },
      {
        description: i18next.t("Personal Information - Country/City"),
        id: FieldNames.currentLocation,
        input: () => <CurrentLocation />
      }
    ];
    options.sort((item, nextItem) =>
      item.description > nextItem.description ? 1 : -1
    );

    return translateAndSortAscendant(options, "description");
  }
};
